

export class Accordion {

  constructor(container) {
    this.container = container;
    this.init();
    this.current = null;
  }

  init() {
    this.container.querySelectorAll('.accordion-toggle').forEach((item) => {
      item.addEventListener('click', this);
    });
  }

  toggle(item) {
    if (this.current) {
      this.current.classList.remove('active');
    }
    if (this.current !== item) {
      item.classList.add('active');
      this.current = item;
    } else {
      this.current = null;
    }

  }

  handleEvent(e) {
    if (e.type !== "click") {
      return;
    }
    this.toggle(e.target.closest('.accordion-item'));
  }
}
